import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";

export class QuantityCalculator extends CalculatorBase{

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}    {
        if(value==null)
            value=this.Field.GetValue();

        let quantity=parseFloat(value);
        if(isNaN(quantity))
            quantity=0;

        if(value.length>0) {
            if(this.Field.GetSalePrice()!='')
                return {Quantity:quantity, RegularPrice: this.Field.GetRegularPrice(),
                    SalePrice:this.Field.GetSalePrice()};
            else
                return {RegularPrice: this.GetRegularPrice(),SalePrice:'',Quantity:quantity}
        }

        else
            return {RegularPrice:'',SalePrice:'',Quantity:0}
    }
}